import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatAccordionItem = createCustomElementWrapper('kat-accordion-item', 'KatAccordionItem', {
    'badgeLabel': 'badge-label',
    'badgeType': 'badge-type',
    'remainsExpanded': 'remains-expanded',
}, {
    'onCollapse': 'collapse',
    'onExpand': 'expand',
}, [
    'label',
    'badge',
]);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/katal-react/es/accordion-item.js
// module id = 1211
// module chunks = 0